module.exports = __webpack_public_path__ + "static/img/bg.6d68502.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shaodong/bg.png
// module id = wUNl
// module chunks = 1